export enum StatusCodeEnum {
  SaleCCApproved = 101,
  SaleCCAuthOnly = 102,
  RefundCCRefunded = 111,
  CreditDebitRefundCCAvsOnly = 121,
  CreditDebitRefundACHPendingOrigination = 131,
  CreditDebitRefundACHOriginating = 132,
  CreditDebitRefundACHOriginated = 133,
  CreditDebitRefundACHSettled = 134,
  SettledDeprecated = 191,
  AllCCACHVoided = 201,
  AllCCACHDeclined = 301,
  CreditDebitRefundACHChargedBack = 331
}
